import { render, staticRenderFns } from "./fence.vue?vue&type=template&id=28494be4&scoped=true&"
import script from "./fence.vue?vue&type=script&lang=js&"
export * from "./fence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28494be4",
  null
  
)

export default component.exports